module.exports = [

  {
    key: 'local',
    domain: /^localhost/,
    canonical: 'https://devint.mapmyfitness.com/',
    name: 'MapMyFitness',
    plural: 'routes',
    apiKey: process.env.MAPMY_FITNESS_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 44829295357,
    abbr: 'MMF',
    uaStoreSlug: 'MMFitness',
    slug: 'fitness',
    shortName: 'mapmyfitness',
    noun: 'workout',
    action: 'training',
    legacySiteID: null,
    activityTypeID: 16,
    iosAppID: 298903147,
    identityAppName: 'MAPMYFITNESS',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-fitness-gps-workout/id298903147?mt=8',
  },

  {
    key: 'devint',
    domain: /devint\.mapmyfitness\.com$/,
    canonical: 'https://devint.mapmyfitness.com/',
    name: 'MapMyFitness',
    plural: 'routes',
    apiKey: process.env.MAPMY_FITNESS_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 44829295357,
    abbr: 'MMF',
    uaStoreSlug: 'MMFitness',
    slug: 'fitness',
    shortName: 'mapmyfitness',
    noun: 'workout',
    action: 'training',
    legacySiteID: null,
    activityTypeID: 16,
    iosAppID: 298903147,
    identityAppName: 'MAPMYFITNESS',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-fitness-gps-workout/id298903147?mt=8',
  },

  {
    key: 'run',
    domain: /mapmyrun\.com$/,
    canonical: 'https://www.mapmyrun.com/',
    name: 'MapMyRun',
    plural: 'runs',
    apiKey: process.env.MAPMY_RUN_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 43211574282,
    abbr: 'MMR',
    uaStoreSlug: 'MMRun',
    slug: 'run',
    shortName: 'mapmyrun',
    noun: 'run',
    action: 'running',
    legacySiteID: 1,
    activityTypeID: 16,
    iosAppID: 291890420,
    identityAppName: 'MAPMYRUN',
    cookieDomain: 'mapmyrun.com',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-run-gps-running-workout/id291890420?mt=8',
  },

  {
    key: 'ride',
    domain: /mapmyride\.com$/,
    canonical: 'https://www.mapmyride.com/',
    name: 'MapMyRide',
    plural: 'rides',
    apiKey: process.env.MAPMY_RIDE_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 43656497834,
    abbr: 'MMRi',
    uaStoreSlug: 'MMRide',
    slug: 'ride',
    shortName: 'mapmyride',
    noun: 'ride',
    action: 'riding',
    activityTypeID: 11,
    legacySiteID: 7,
    iosAppID: 292223170,
    identityAppName: 'MAPMYRIDE',
    cookieDomain: 'mapmyride.com',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-ride-gps-cycling-route/id292223170?mt=8',
  },

  {
    key: 'walk',
    domain: /mapmywalk\.com$/,
    canonical: 'https://www.mapmywalk.com/',
    name: 'MapMyWalk',
    plural: 'walks',
    apiKey: process.env.MAPMY_WALK_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 34785190853,
    abbr: 'MMW',
    uaStoreSlug: 'MMWalk',
    slug: 'walk',
    shortName: 'mapmywalk',
    noun: 'walk',
    action: 'walking',
    activityTypeID: 9,
    legacySiteID: 8,
    iosAppID: 307861492,
    identityAppName: 'MAPMYWALK',
    cookieDomain: 'mapmywalk.com',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-walk-gps-walking-step/id307861492?mt=8',
  },

  {
    key: 'hike',
    domain: /mapmyhike\.com$/,
    canonical: 'https://www.mapmyhike.com/',
    name: 'MapMyHike',
    plural: 'hikes',
    apiKey: process.env.MAPMY_HIKE_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 38747896643,
    abbr: 'MMH',
    uaStoreSlug: 'MMHike',
    slug: 'hike',
    shortName: 'mapmyhike',
    noun: 'hike',
    action: 'hiking',
    activityTypeID: 24,
    legacySiteID: 9,
    iosAppID: 307861852,
    identityAppName: 'MAPMYHIKE',
    cookieDomain: 'mapmyhike.com',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-hike-gps-hiking-tracker/id307861852?mt=8',
  },

  {
    key: 'fitness',
    domain: /mapmyfitness\.com$/,
    canonical: 'https://www.mapmyfitness.com/',
    name: 'MapMyFitness',
    plural: 'routes',
    apiKey: process.env.MAPMY_FITNESS_KEY,
    apiSecret: '',
    apiCallback: '',
    fbAppID: 44829295357,
    abbr: 'MMF',
    uaStoreSlug: 'MMFitness',
    slug: 'fitness',
    shortName: 'mapmyfitness',
    noun: 'workout',
    action: 'training',
    legacySiteID: null,
    activityTypeID: 16,
    iosAppID: 298903147,
    identityAppName: 'MAPMYFITNESS',
    cookieDomain: 'mapmyfitness.com',
    appStoreLink: 'https://itunes.apple.com/us/app/map-my-fitness-gps-workout/id298903147?mt=8',
  },

]




// WEBPACK FOOTER //
// ./shared/constants/sites.js